export const ADMIN_ROLE = 'ADMIN';
export const META_ADMIN_ROLE = 'META_ADMIN';
